export const permission = {
  MYMEDAX_DEVICE_CREATE: 'MYMEDAX_DEVICE_CREATE',
  MYMEDAX_DEVICE_READ: 'MYMEDAX_DEVICE_READ',
  MYMEDAX_DEVICE_UPDATE: 'MYMEDAX_DEVICE_UPDATE',
  MYMEDAX_DEVICE_DELETE: 'MYMEDAX_DEVICE_DELETE',
};
